/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterItemDto } from '../../models/filter-item-dto';
import { PaginatedDtoOfBlogPostListItemDto } from '../../models/paginated-dto-of-blog-post-list-item-dto';
import { SortItemDto } from '../../models/sort-item-dto';

export interface GetPostsList$Params {
  sortItem?: SortItemDto;
  limit: number;
  page: number;

/**
 * Filters for the search.
 * For admin, `field` is the name of the field in the document. Can be a nested path. For example:
 * `[{ field: 'categories.id', values: [1] }]` while searching products to filter by category with ID '1'.
 * Or `[{ field: 'customerId', values: [101] }]` while searching orders to filter orders created by customer with ID '101'.
 *
 * For client, `field` is explicitly allowed keywords to prevent data leakage. For example:
 * `[{ field: 'manufacturerId', values: ['rosa', 'solway'] }]` while searching products to filter by attributes.
 * Or `[{ field: 'categoryId', values: [6] }]` while searching blog posts to filter by category with ID '6'.
 * Or `[{ field: 'productId', values: [44] }]` while searching product reviews to filter by product with ID '44'.
 */
  filters?: Array<FilterItemDto>;
  categoryId?: number;
  lastPosts?: boolean;
}

export function getPostsList(http: HttpClient, rootUrl: string, params: GetPostsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfBlogPostListItemDto>> {
  const rb = new RequestBuilder(rootUrl, getPostsList.PATH, 'get');
  if (params) {
    rb.query('sortItem', params.sortItem, {});
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
    rb.query('filters', params.filters, {});
    rb.query('categoryId', params.categoryId, {});
    rb.query('lastPosts', params.lastPosts, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfBlogPostListItemDto>;
    })
  );
}

getPostsList.PATH = '/api/v1/blog/posts';
